import { Box } from "@mui/material"
import React from "react"
import PropTypes from "prop-types"

function TabPanel(props) {
    const { children, value, index, ...other} = props

    return (
        <div role='tabpanel' hidden={value !== index} id={`ambunet-tabpanel-${index}`} aria-labelledby={`ambunet-tab-${index}`} {...other}>
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired

}

export default TabPanel